module.exports = __webpack_public_path__ + "assets/d73f94cfcecf54516fa323a9281af4c1.mp4";